import React, { useState, useEffect } from 'react';

import { ContentBox } from "../ContentBox"
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { SingleInput, SingleSelect } from '../../Res/BaseInput';
import { EnableBadge, AddButton, CancelButton, SearchButton, Space, SingleLink } from '../../Res/BaseButton';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { Pagination } from '../../Res/Pagination';
import { uuid, getItemsInfo } from '../../../../item/ItemTools';
import { getUserInfoCompanyId, setVal2Token, getval2Token } from '../../../Login/Auth';

import { ReqCustomerContractList } from '../../../../item/ItemCustomerContract';
import { api_getCustomerContractList } from '../../../../api/apiCustomerContract';
import { WageType_Arr } from '../../../../item/ItemCustomerPosition';

export function CustomerContractList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")

    const [companyId] = useState(getUserInfoCompanyId())
    const [customerContractList, setCustomerContractList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)
    const [validCount, setValidCount] = useState(0)

    const [mReqCustomerContractList, setReqCustomerContractList] = useState({})

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqCustomerContractList = new ReqCustomerContractList({ companyId, start, limit })
            if (url === "") {
                toSearch({ items: mReqCustomerContractList, page: url.page })
            } else {
                mReqCustomerContractList.fromJson(url)
                console.log(mReqCustomerContractList)
                toSearch({ items: mReqCustomerContractList, page: url.page })
            }
        }
    }, [id])

    // useEffect(() => {
    //     if (customerContractList.length === 0) {
    //         var start = (page - 1) * limit;
    //         var mReqCustomerContractList = new ReqCustomerContractList({ companyId, start, limit })
    //         toSearch({ items: mReqCustomerContractList })
    //     }
    // }, [])

    function toSearch({ items, page = 1 }) {
        //console.log("toSearch")
        //console.log(items)
        var start = (page - 1) * limit;
        setPage(page)
        var mReqCustomerContractList = new ReqCustomerContractList({ companyId, start, limit })
        if (items !== undefined)
            mReqCustomerContractList.fromJson(items)
        setReqCustomerContractList(mReqCustomerContractList)
        setVal2Token("url", mReqCustomerContractList, id)
        getCustomerContractList(mReqCustomerContractList)
    }

    function getCustomerContractList(mReqCustomerContractList) {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        //console.log("getCustomerContractList")
        //console.log(mReqCustomerContractList)
        console.log(mReqCustomerContractList)
        api_getCustomerContractList({
            mReqCustomerContractList,
            success: (obj) => {
                //console.log(obj)
                setCustomerContractList(obj.list)
                setCount(obj.counts.count)
                setValidCount(obj.counts.validCount)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/CustomerContractAdd");
    }


    var baseTitle = "廠商合約列表"
    var baseContent =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"有效合約數"} count={validCount} />
                    {/* <DisableBadge text={"下工"} count={disableCount} /> */}
                    <AddButton name={"新增"} action={toAdd} />
                </div>
            </div>
            <Space />
            <CustomerContractListBox list={customerContractList} srl={setCustomerContractList} count={count} page={page} sp={toSearch} />
        </>
    return (
        <>
            <CustomerContractListSearch action={toSearch} item={mReqCustomerContractList} />
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}

function CustomerContractListSearch({ action, item }) {
    const [companyName, setCompanyName] = useState("")
    const [workAddress, setWorkAddress] = useState("")
    const [contractStatus, setContractStatus] = useState("")
    const [jobName, setJobName] = useState("")
    const [jobType, setJobType] = useState("")
    const [contractMaturity, setContractMaturity] = useState("")

    useEffect(() => {
        setCompanyName(item.companyName === undefined ? "" : item.companyName)
        setWorkAddress(item.workAddress === undefined ? "" : item.workAddress)
        setContractStatus(item.contractStatus === undefined ? "" : item.contractStatus)
        setJobName(item.jobName === undefined ? "" : item.jobName)
        setJobType(item.jobType === undefined ? "" : item.jobType)
        setContractMaturity(item.contractMaturity === undefined ? "" : item.contractMaturity)
        console.log(item)
    }, [item])

    function toClear() {
        setCompanyName("")
        setWorkAddress("")
        setContractStatus("1")
        setJobName("")
        setJobType("")
        setContractMaturity("")
    }

    function toSearch() {
        var mReqResumeList = new ReqCustomerContractList({
            companyName, workAddress, contractStatus, jobName, jobType, contractMaturity
        })
        action({ items: mReqResumeList })
    }


    var content =
        <>
            <div className="row">
                <SingleInput title={"以廠商名稱搜尋"} val={companyName} action={setCompanyName} size={4} />
                <SingleInput title={"以工作地址搜尋"} val={workAddress} action={setWorkAddress} size={4} />
                <SingleSelect title={"合約狀態"}
                    val={contractStatus}
                    attr={[
                        { "val": "1", "name": "有效" },
                        { "val": "2", "name": "過期" },
                        { "val": "3", "name": "停用" },
                        { "val": "", "name": "全部" }
                    ]}
                    action={setContractStatus}
                    size={4}
                />
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <SingleInput title={"以職缺名稱搜尋"} val={jobName} action={setJobName} size={4} />
                <SingleSelect title={"職缺類型"}
                    val={jobType}
                    attr={[
                        { "val": "", "name": "全部" },
                        { "val": "1", "name": "月薪" },
                        { "val": "2", "name": "時薪" },
                        { "val": "3", "name": "代招" }
                    ]}
                    action={setJobType}
                    size={4}
                />
                <SingleSelect title={"以合約到期日搜尋"}
                    val={contractMaturity}
                    attr={[
                        { "val": "", "name": "無限期" },
                        { "val": "1", "name": "一個月" },
                        { "val": "2", "name": "二個月" },
                        { "val": "3", "name": "三個月" },
                    ]}
                    action={setContractMaturity}
                    size={4}
                />
            </div>


            <div className="row m-t-sm m-t-sm">
                <div className="col-sm-4 col-sm-offset-5">
                    <CancelButton name={"清除"} action={toClear} />
                    <SearchButton action={toSearch} />
                </div>
            </div>

        </>
    return (
        <ContentBox hasTitle={false} content={content} hasDrawer={false} />
    )
}

function CustomerContractListBox({ list, srl, count, page, sp }) {
    const [customerContractList, setCustomerContractList] = useState([])
    const [itemList, setItemList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        if (list !== undefined && customerContractList !== list) {
            setCustomerContractList(list)
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + list.length)
            setItemList(setTableList(list))
            setPage(page)
        }

        if (count !== mCount) {
            setCount(count)
        }
    }, [list, count])

    function setTableList(list) {
        var itemList = []
        for (var i = 0; i < limit; i++) {
            if (list[i] !== undefined) {
                itemList.push(<CustomerContractBox key={list[i].customerContractId} item={list[i]} />)
            } else {
                itemList.push(<CustomerContractBox key={"resumeId" + i} />)
            }
        }
        return itemList
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (itemList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-1">簽約日期</th>
                                    <th className="text-center sorting col-sm-2">廠商名稱</th>
                                    <th className="text-center sorting col-sm-3">職缺</th>
                                    <th className="text-center sorting col-sm-4">地點</th>
                                    <th className="text-center sorting col-sm-1">共補</th>
                                    <th className="text-center sorting col-sm-1">狀態</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemList.map((item) => (
                                        item
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function CustomerContractBox({ item }) {
    const [mItem, setItem] = useState({})
    const [customerContractId, setCustomerContractId] = useState("")
    const [companyName, setCompanyName] = useState("")
    const [signAt, setSignAt] = useState("")
    const [isPublic, setIsPublic] = useState("")
    const [status, setStatus] = useState("")
    const [positions, setPositions] = useState([])


    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            // console.log(item)
            setItem(item)
            setCustomerContractId(item.customerContractId)
            setCompanyName(item.companyName)
            setSignAt(moment(item.signAt).format('YYYY-MM-DD'))
            setIsPublic(item.isPublic === 1 ? "是" : "否")
            // console.log(typeof item.positions)
            try {
                setPositions(JSON.parse(item.positions))
            } catch (error) {
                var buf = new Buffer(item.positions)
                // console.log(buf.toString()) 
                setPositions(JSON.parse(buf))
            }

            if (item.isDisable === 1) {
                setStatus(<span className="text-danger">停用</span>)
            } else if (item.days < 0) {
                setStatus(<span className="text-danger">過期</span>)
            } else {
                setStatus(<span className="text-info">有效</span>)
            }

        }
    }, [item])

    function toContractorResumeEdit() {
        console.log(customerContractId)
        var tokenId = uuid(128, 64)
        setVal2Token("customerContractId", customerContractId, tokenId)
        //window.location.assign("/ContractorResumeDetail/" + mTokenId);
        window.open("/CustomerContractDetail/" + tokenId, "_blank");
    }

    return (
        <tr role="row">
            <td className="text-center">{signAt}&nbsp;</td>
            <td className="text-center"><SingleLink link={"CustomerContractDetail"} name={companyName} Key={"customerContract"} val={{customerContractId}}  ></SingleLink>&nbsp;</td>
            <td className="text-center">
                {
                    positions.map((item, index) => (
                        <span key={"job" + index}>
                            <SingleLink
                                link={"CustomerPositionDetail"}
                                name={item.job + "/" + item.shift + "/" + getItemsInfo({ items: WageType_Arr, val: item.wageType })}
                                Key={"customerPosition"} val={{ customerContractId, customerPositionId: item.customerPositionId }}  ></SingleLink>
                            <br></br>
                        </span>
                    ))
                }
            </td>
            <td className="text-center">
                {
                    positions.map((item, index) => (
                        <span key={"work" + index}>
                            {item.workPlace}/{item.workAddress}
                            <br></br>
                        </span>
                    ))
                }
            </td>
            <td className="text-center">{isPublic}</td>
            <td className="text-center"><span>{status}</span></td>
        </tr>
    )
    /**
     * 
      <tr>
        <td>
          <div className="feed-element">
            {avatar}
          </div>
        </td>
        <td style={{ verticalAlign: "middle" }}><div>{account.mobile}</div></td>
        <td style={{ verticalAlign: "middle" }}>{account.nickName}</td>
        <td style={{ verticalAlign: "middle" }}>{account.email}</td>
        <td style={{ verticalAlign: "middle" }}>{status}</td>
        <td style={{ verticalAlign: "middle" }}>{creatAt}</td>
        <td style={{ verticalAlign: "middle" }}>
          <a href="#A" className="btn btn-social-icon btn-linkedin" onClick={toCompanyList}><i className="fa fa-eye"></i></a>
        </td>
      </tr>
     */
}
